import { render, staticRenderFns } from "./HomeFeaturedProducts.vue?vue&type=template&id=0d979c33&scoped=true&"
import script from "./HomeFeaturedProducts.vue?vue&type=script&lang=ts&"
export * from "./HomeFeaturedProducts.vue?vue&type=script&lang=ts&"
import style0 from "./HomeFeaturedProducts.vue?vue&type=style&index=0&id=0d979c33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d979c33",
  null
  
)

export default component.exports